<template>
    <div>
        <div v-if="user == null">
            Loading...
        </div>
        <div v-if="user != null">
            {{user}}
        </div>
    </div>
</template>

<script>
import firebase from '@/firebase'

export default {
    data() {
        return {
            id: this.$route.params.id,
            user: null,
        }
    },

    async mounted() {
        this.user = await firebase.functions.httpsCallable('getUser')({ userName: this.id })
    }
}
</script>


<style>

</style>